import { useEffect, useState } from "react";

// Hash routes. crm-api's changes feed stamps /#/contacts/<id>/show and
// /#/companies/<id>/show on every item and Masora stores them, so both must
// keep opening that record. People live inside companies: a person's link
// opens their editor on the Companies page, under their company.
export type Route =
  | { page: "dashboard" }
  | { page: "companies"; id?: number; addPerson?: true }
  | { page: "person"; id: number };

export function parseHash(hash: string): Route {
  const [resource, rawId, sub, action] = hash.replace(/^#\/?/, "").split(/[/?]/).filter(Boolean);
  const n = Number(rawId);
  const id = Number.isInteger(n) && n > 0 ? n : undefined;
  if (resource === "contacts") return id ? { page: "person", id } : { page: "companies" };
  if (resource === "companies") {
    if (!id) return { page: "companies" };
    return sub === "people" && action === "new" ? { page: "companies", id, addPerson: true } : { page: "companies", id };
  }
  return { page: "dashboard" };
}

export function href(route: Route): string {
  switch (route.page) {
    case "dashboard": return "#/";
    case "person": return `#/contacts/${route.id}/show`;
    case "companies":
      if (!route.id) return "#/companies";
      return route.addPerson ? `#/companies/${route.id}/people/new` : `#/companies/${route.id}/show`;
  }
}

export function navigate(route: Route): void {
  window.location.hash = href(route);
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseHash(window.location.hash));
  useEffect(() => {
    const onChange = () => setRoute(parseHash(window.location.hash));
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}
